import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/company_has_protocol',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/company_has_protocol/' + id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/company_has_protocol'
  if (data.id) {
    method = 'put'
    url = '/company_has_protocol/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (id_company, id_protocol) {
  return request({
    url: '/company_has_protocol/' + id_company + '/' + id_protocol,
    method: 'delete',
  })
}
